import React from "react";
import { useField } from "formik";
import FieldError from "./FieldError";

const FormikCheckbox = ({ children, name }) => {
  const [field, meta] = useField({ name, type: "checkbox" });
  const errorId = `${name}-error`;
  const hasError = Boolean(meta.touched && meta.error);

  return (
    <div
      className={`form-group terms registration-field${
        hasError ? " field-invalid" : ""
      }`}
    >
      <label className="container_check">
        <input
          {...field}
          type="checkbox"
          checked={field.value}
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
        />
        <span className="checkmark" aria-hidden="true" />
        {children}
      </label>
      <FieldError id={errorId} error={meta.error} touched={meta.touched} />
    </div>
  );
};

export default FormikCheckbox;
